/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { get } from 'lodash';
import { DateTime as LuxonDateTime } from 'luxon';
import { formatTicketDateTime } from '../../../formatTicketDateTime';
import constants from '../constants';

export class DateTime {
  constructor() {
    this.next = null;
  }

  setNext(handler) {
    this.next = handler;

    return handler;
  }

  handle(params) {
    if (params?.token?.startsWith?.(constants.DATE_TIME)) {
      const { token, context, util } = params;

      const isoDatePath = token.slice(10);
      const isoDate = get(context, isoDatePath);

      if (!isoDate) {
        return constants.EMPTY;
      }

      const { dateFormat, use24HourTimeFormat, timeZone, userLocale } = util ?? {};

      const dt = LuxonDateTime.fromISO(isoDate);

      if (!dt?.isValid) {
        return constants.EMPTY;
      }

      return formatTicketDateTime(isoDate, {
        dateFormat,
        use24HourTimeFormat,
        timeZone,
        mode: 'datetime',
        locale: userLocale,
      });
    }

    return this?.next?.handle?.(params);
  }
}
